export default __webpack_public_path__ + "static/media/main.31d6cfe0.less";